<script setup>
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';

import MultiChannelCampaignForm from 'dashboard/components-next/Campaigns/Pages/CampaignPage/MultiChannelCampaign/MultiChannelCampaignForm.vue';

const emit = defineEmits(['close']);

const store = useStore();
const { t } = useI18n();

const addCampaign = async campaignDetails => {
  try {
    await store.dispatch('multiChannelCampaigns/create', campaignDetails);
    useAlert(t('CAMPAIGN.MULTI_CHANNEL.CREATE.FORM.API.SUCCESS_MESSAGE'));
  } catch (error) {
    const errorMessage =
      error?.response?.message ||
      t('CAMPAIGN.MULTI_CHANNEL.CREATE.FORM.API.ERROR_MESSAGE');
    useAlert(errorMessage);
  }
};

const handleSubmit = campaignDetails => addCampaign(campaignDetails);
const handleClose = () => emit('close');
</script>

<template>
  <div
    class="w-[30rem] z-50 min-w-0 absolute top-10 ltr:right-0 rtl:left-0 bg-n-alpha-3 backdrop-blur-[100px] p-6 rounded-xl border border-n-weak shadow-md flex flex-col gap-5 max-h-[82vh] overflow-y-auto"
  >
    <h3 class="text-lg font-medium text-n-slate-12">
      {{ t('CAMPAIGN.MULTI_CHANNEL.CREATE.TITLE') }}
    </h3>
    <MultiChannelCampaignForm @submit="handleSubmit" @cancel="handleClose" />
  </div>
</template>
